interface Attribute { S?: string; N?: string }
export type AlertDevice = Record<string, Attribute | undefined>;
interface CurrentValues {
  waterLevel: string;
  flowRate: string;
  velocity: string;
  lastReceivedAt: number | null;
}

const read = (device: AlertDevice, key: string) => device[key]?.S ?? device[key]?.N ?? '';
const numeric = (value: string): number | null => value.trim() && Number.isFinite(Number(value)) ? Number(value) : null;

export function configuredAlerts(device: AlertDevice, current: CurrentValues, now: number): string[] {
  const alerts: string[] = [];
  const metrics = [
    {prefix: 'WATER_LEVEL', label: '水位', value: current.waterLevel},
    {prefix: 'WATER_FLOW', label: '流量', value: current.flowRate},
    {prefix: 'VELOCITY', label: '流速', value: current.velocity},
  ];
  metrics.forEach(({prefix, label, value}) => {
    const measured = numeric(value);
    const lower = numeric(read(device, `${prefix}_LOWER_THRESHOLD`));
    const upper = numeric(read(device, `${prefix}_THRESHOLD`));
    if (measured === null) return;
    if (lower !== null && measured < lower) alerts.push(`${label}：下限未満`);
    else if (upper !== null && measured > upper) alerts.push(`${label}：上限超過`);
  });
  // Vibration alerts use the server's latest SENSOR_1003 evaluation.
  ['FRQ_A4', 'FRQ_A5'].forEach((prefix) => {
    const status = read(device, `${prefix}_STATUS`);
    if (status === 'lower' && numeric(read(device, `${prefix}_LOWER_THRESHOLD`)) !== null) alerts.push(`${prefix}：下限未満`);
    if (status === 'higher' && numeric(read(device, `${prefix}_THRESHOLD`)) !== null) alerts.push(`${prefix}：上限超過`);
  });
  const minutes = numeric(read(device, 'NO_DATA_ALERT_MINUTES'));
  if (read(device, 'DEVICE_STATUS') === 'ACTIVE' && read(device, 'ALERT_RECEIPT_EMAIL').trim() &&
      minutes !== null && Number.isInteger(minutes) && minutes >= 5 && current.lastReceivedAt !== null &&
      now - current.lastReceivedAt >= minutes * 60000) alerts.push(`未受信：${minutes}分以上`);
  return alerts;
}
